import type { InvoiceShopInfo } from '@services/chatwoot'
import { initializeSupport } from '@services/support'
import { useEffect, useRef } from 'react'

interface UseSupportWidgetOptions {
  enabled: boolean
  shopInfo: InvoiceShopInfo | null
}

export function useSupportWidget({
  enabled,
  shopInfo,
}: UseSupportWidgetOptions): void {
  const initializedRef = useRef(false)
  useEffect(() => {
    if (!enabled || !shopInfo) return

    const hasChatwootIdentity = Boolean(
      shopInfo.chatwoot_identifier?.trim() &&
        shopInfo.chatwoot_identifier_hash?.trim(),
    )
    if (!hasChatwootIdentity) return

    void initializeSupport(shopInfo).then(success => {
      if (success) {
        initializedRef.current = true
      }
    })
  }, [enabled, shopInfo])
}
